module.exports = __webpack_public_path__ + "img/very-sad-emoji.1da77a9c.svg";